import React, { Component } from 'react';
import { Col, Row, Button } from 'antd';
import { inject, observer } from 'mobx-react';
import qs from 'qs';

@inject('store')
@observer
export class NewSubscriptionView extends Component {
    async componentDidMount() {
        const parsed = qs.parse(this.props.location.search.slice(1));
        await this.props.store.billingStore.getPackages(parsed.bot_type || 'apex');
    }

    render() {
        const parsed = qs.parse(this.props.location.search.slice(1));

        return (
            <div>
                <h1 style={{ textAlign: 'center' }}>Choose your Package</h1>

                <Row type="flex" justify="center" gutter={24}>
                    {this.props.store.billingStore.packages.map(p => {
                        return (
                            <Col md={8} key={p._id}>
                                <div className="package_wrapper">
                                    <div className="package">
                                        <div className="header" style={{ height: 180 }}>
                                            <h3>{p.name}</h3>
                                            {p.rrp_price ? (
                                                <div
                                                    style={{
                                                        fontSize: 22,
                                                        textDecoration: 'line-through'
                                                    }}
                                                >
                                                    RRP {p.rrp_price}
                                                </div>
                                            ) : null}
                                            <div className="sub-heading">{p.price_description}</div>
                                            <div className="sub-heading">{p.rrp_description}</div>
                                        </div>
                                        <div className="package-features">
                                            <ul>
                                                {p.limits.map((limit, i) => {
                                                    return (
                                                        <li key={i}>
                                                            <div className="column-9p">
                                                                {limit.label}
                                                            </div>
                                                            <div className="column-1p">
                                                                <em className={limit.icon} />
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                            <div className="bottom-row">
                                                <Button
                                                    block
                                                    size="large"
                                                    type={'primary'}
                                                    onClick={() => {
                                                        this.props.history.push(
                                                            `/a/subscriptions/order?package=${
                                                                p.internal_id
                                                            }&bot_type=${parsed.bot_type || 'apex'}`
                                                        );
                                                    }}
                                                >
                                                    Subscribe Now
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                    <div className="ant-col ant-col-md-18" style={{ marginTop: 5 }}>
                        <div style={{ textAlign: 'center' }}>
                            * Maximum allocation is the total amount of funds which can be used to
                            open positions at any one time.
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            * Early adopter price will be in effect for as long as the subscription
                            remains active. This package may not be available in the future
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            * Price excludes VAT (if applicable).
                        </div>
                    </div>
                </Row>
            </div>
        );
    }
}

//      <Col md={18} style={{ marginTop: 5 }}>
//         {p.small_print.map((text, i) => (
//             <div key={i} style={{ textAlign: 'center' }}>
//                 {text}
//             </div>
//         ))}
//     </Col>
// </Fragment> */}



// WEBPACK FOOTER //
// ./src/Account/SubscriptionsView/NewSubscriptionView.js